import {useRef, useState} from 'react';
import axios from 'axios';
import Finish from "./finish";
import CONFIG from "../../../../../config";

interface StepData {
  StepTwoExamenes: string;
}

interface AgendaStep4Examenes {
  setStepValue: (value: string) => void;
  setCurrentStep: (value: string) => void;
  stepData: StepData;
}

interface Examen {
  id: string;
  encuesta_para_agendar: string;
  way_to_schedule: string;
  code: string;
  name: string;
  text: string;
}

interface Specialty {
  code: string;
  name: string;
}

export default function AgendaStep4Examenes({ setStepValue, setCurrentStep, stepData }: AgendaStep4Examenes) {

  const [canContinue, setCanContinue] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedTypePatient, setSelectedTypePatient] = useState('');
  const [specialties, setSpecialties] = useState<Specialty[]>([]);
  const [typeExamen, setTypeExamen] = useState('');
  const [loadingSpecialties, setLoadingSpecialties] = useState(false);
  const [loadingSelect, setLoadingSelect] = useState(false);
  const [selectedTypeBenefit, setSelectedTypeBenefit] = useState('');
  const [parte, setParte] = useState('');
  const [examen, setExamen] = useState('');
  const [nameExamen, setNameExamen] = useState('');
  const [examenList, setExamenList] = useState<Examen[]>([]);
  const [question, setQuestion] = useState(false);
  const [wayToSchedule, setWayToSchedule] = useState('');
  const [finish, setFinish] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState('/assets/img/agenda/body-clean.png');
  const [loadingIndications, setLoadingIndications] = useState(false);
  const [indications, setIndications] = useState('');
  const [urlPdf, setUrlPdf] = useState('');
  const [downloadPdf, setDownloadPdf] = useState(false);

  const selectTypeBenefitRef = useRef(null);
  const selectPartRef = useRef(null);
  const selectExamenRef = useRef(null);
  const apiUrl = (CONFIG.APP.API_SCHEDULE_URL ? CONFIG.APP.API_SCHEDULE_URL : '');

  const resetData = () => {
    setSelectedTypeBenefit('');
    setBackgroundImage('/assets/img/agenda/body-clean.png');
    setParte('');
    setExamen('');
    setNameExamen('');
    setTypeExamen('');
    setExamenList([]);
    setQuestion(false);
    setCanContinue(false);
  };

  const currentStep = (value:string) => {

    if (!question) {
      let idOffice = '';
      if (stepData.StepTwoExamenes === 'maipu_examenes') {
        idOffice = '239';
      } else if (stepData.StepTwoExamenes === 'providencia_examenes') {
        idOffice = '2';
      }
      setFinish(true);
      (window as any).show_agenda_eniax({"sped_id": selectedTypeBenefit, "doc_id": examen, "office_id": idOffice})
      return false;
    }
    setCurrentStep(value);
    setStepValue(JSON.stringify({
      patient: selectedTypePatient,
      prestacion: selectedTypePatient,
      parte: parte,
      examen: examen,
      examenName: nameExamen,
      sped_id: selectedTypeBenefit
    }));
    console.log('stepData', stepData)
  };

  const scrollToElement = (nextElement: React.RefObject<HTMLElement>) => {
    const selectPosition = nextElement.current!.getBoundingClientRect().top + window.pageYOffset - 30;

    window.scrollTo({
      top: selectPosition,
      behavior: 'smooth'
    });
  };

  const handleSetPrestacion = (value: string) => {
    setSelectedTypeBenefit(value);
  };


  const getSpecialties = async (typePatient: string) => {
    setLoadingSpecialties(true);
    try {
      const response = await axios.post(`${apiUrl}wp-json/agenda/v1/specialties`, {
        'type_patient': typePatient
      });
      setSpecialties(response.data.data ?? []);
    } catch (error) {
      console.error('Error fetching specialties:', error);
    } finally {
      setLoadingSpecialties(false);
    }
  };


  const handleQuerySpecialties = async (typePatient: string) => {

    setSpecialties([]);
    if (typePatient === '') {
      return false;
    }
    setLoadingSpecialties(true);
    let patient = '';
    if (typePatient === '2') {
      patient = 'pediatrica';
    } else if (typePatient === '3') {
      patient = 'adulto';
    }
    await getSpecialties(patient);
  };

  const handleQuery = async (typePatient:string, part:string) => {
    setLoadingSelect(true);
    let idOffice = 0;

    if (stepData.StepTwoExamenes === 'maipu_examenes') {
      idOffice = 239;
    } else if (stepData.StepTwoExamenes === 'providencia_examenes') {
      idOffice = 2;
    }

    try {
      const response = await axios.post(`${apiUrl}wp-json/agenda/v1/exams`, {
        type: typePatient,
        part: part,
        specialty_code: selectedTypeBenefit,
        idOffice: idOffice
      });

      const examData = response.data
      setExamenList(examData.data ? examData.data : []);
    } catch (error) {
    } finally {
      setLoadingSelect(false);
    }
  };

  const handleSetTypeExamen = (part:string) => {
    setExamenList([]);
    handleQuery(selectedTypePatient, part);
  };


  const handleSetParte = (value:string, partBody:string) => {
    setBackgroundImage(value);
    setParte(partBody);
    setCanContinue(false);
    setExamen('');
    handleSetTypeExamen(partBody);
    scrollToElement(selectExamenRef);
    setIndications('');
    setUrlPdf('');
  }

  const handleSetExamen = (value: string, text: string) => {
    setNameExamen(text);
    setExamen(value);
    setCanContinue(false);
    getIndications(value);
    const selectedExamen = examenList.find(item => item.id === value);
    if (selectedExamen) {
      setQuestion(selectedExamen.encuesta_para_agendar === 'SI');
      setWayToSchedule(selectedExamen.way_to_schedule);
    }
  };

  const formatAsList = (htmlContent: string): string => {
    return htmlContent
        .replace(/<p>/g, '<ul><li>')
        .replace(/<\/p>/g, '</li></ul>')
        .replace(/<br\s*\/?>/g, '</li><li>');
  };

  const getIndications = async (id: string) => {
    setLoadingIndications(true);
    setIndications('');
    setUrlPdf('');
    try {
      const response = await axios.post(`${apiUrl}wp-json/imagenologia/v1/indications/pdf`, {
        code: id
      });

      const rawHtml = response.data?.info?.indications ?? '';
      const formattedHtml = formatAsList(rawHtml);
      setUrlPdf(response.data?.info?.pdf ?? '');
      setIndications(formattedHtml);
      setDownloadPdf(response.data?.info?.pdf === '' || typeof response.data?.info?.pdf === 'undefined');
    } catch (error) {
      console.error('Error fetching indications:', error);
      setCanContinue(true);
    } finally {
      setLoadingIndications(false);
      setCanContinue(true);
    }
  }

  return (
      <>
        {finish && (<Finish/>)}
        {!finish && (<div>
              <div className='agenda-container wrapper_agenda'>
                <div className='mt-30'>
                  <h2 className='pretitle'>Reserva de hora</h2>
                  <h3 className='content-title'>Ingrese datos del examen</h3>
                </div>

                <div className='mt-30 mb-30 fz-13 lh-24 bd-1 bd-radius-8 p-16 d-flex wrapper_agenda bs-border-box bg-white'>
                  <img src="/assets/img/agenda/info.svg" width='24' height='24' alt=""
                       className='mr-10 d-block position-relative t-3' />
                  <div className='w-316'>
                    Si tu examen no está disponible en el listado o está asignado a un médico en particular, debes llamar a nuestro call center al número
                    2 2362 5400
                  </div>
                </div>

                <div className="w-full centro mt-30 mb-30">
                  <div className="d-flex mb-10">
                    <span className="paragraph"><strong>Seleccione tipo de paciente</strong></span>
                  </div>
                  <div className="d-flex flex-center">
                    <select
                        name="patient"
                        id="patient"
                        className='i2b-select select-cuadrado'
                        onChange={e => {
                          if (e.target.value === '2') {
                            setSelectedTypePatient('pediatrica');
                          } else if (e.target.value === '3') {
                            setSelectedTypePatient('adulto');
                          }

                          scrollToElement(selectTypeBenefitRef);

                          handleQuerySpecialties(e.target.value);
                          setLoadingSelect(false);
                          resetData();
                        }}>
                      <option value="">Tipo de paciente</option>
                      <option value="2">Pediátrico – Menor a 15 años</option>
                      <option value="3">Adulto – Mayor o igual a 15 años</option>
                    </select>
                  </div>
                </div>

                <div className="w-full centro mt-30 mb-30">
                  <div className="d-flex mb-10">
            <span className="paragraph">
              <strong>Seleccione tipo de prestación</strong>
            </span>
                  </div>
                  <div className="d-flex flex-center">
                    <select
                        ref={selectTypeBenefitRef}
                        name="prestacion" id="prestacion" disabled={loadingSpecialties}
                        className={loadingSpecialties ? 'wait i2b-select select-cuadrado' : 'i2b-select select-cuadrado'}
                        onChange={e => {
                          handleSetPrestacion(e.target.value);
                          setBackgroundImage('/assets/img/agenda/body-clean.png');
                          setParte('');
                          scrollToElement(selectPartRef);
                        }}>
                      {loadingSpecialties && (<option value=''>Cargando...</option>)}
                      {!loadingSpecialties && (<option value='0' selected>Elija una opción</option>)}
                      {
                        specialties.map((specialty) => (
                            <option key={specialty.code} value={specialty.code}>{specialty.name}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>

                {selectedTypePatient === 'pediatrica' && (selectedTypeBenefit === 'scanner' || selectedTypeBenefit === 'resonancia_magnetica') &&
                    (
                        <div className='mt-30 mb-30 fz-13 lh-24 bd-radius-8 p-16 d-flex wrapper_agenda bs-border-box bg-warning'>
                          <img src="/assets/img/agenda/warning.svg" width='24' height='24' alt=""
                               className='mr-10 d-block position-relative t-3' />
                          <div className='w-316'>
                            Si el paciente es menor de 8 años, este examen tiene condiciones especiales por lo que debes agendar a
                            través de nuestro call center al número 2 2362 5400
                          </div>
                        </div>
                    )
                }

                <div className="w-full centro mt-30 mb-30" ref={selectPartRef}>
                  {selectedTypeBenefit !== '' &&
                      <>
                        <div className="d-flex mb-10 mt-30">
                          <span className="paragraph"><strong>Seleccione parte del cuerpo</strong></span>
                        </div>

                        <div className='agenda-body'>
                          <div className='preload-images hidden'>
                            <img src="/assets/img/agenda/body-head.png" width="1" height="1" alt="" />
                            <img src="/assets/img/agenda/body-trunk.png" width="1" height="1" alt="" />
                            <img src="/assets/img/agenda/body-legs.png" width="1" height="1" alt="" />
                          </div>
                          <div className='agenda-body' style={{ backgroundImage: `url(${backgroundImage})` }}>
                            <div className='agenda-head'
                                 onClick={() => handleSetParte('/assets/img/agenda/body-head.png', 'cabeza')}></div>
                            <div className='agenda-arms'
                                 onClick={() => handleSetParte('/assets/img/agenda/body-arms.png', 'brazos')}></div>
                            <div className='agenda-trunk'
                                 onClick={() => handleSetParte('/assets/img/agenda/body-trunk.png', 'tronco')}></div>
                            <div className='agenda-legs'
                                 onClick={() => handleSetParte('/assets/img/agenda/body-legs.png', 'piernas')}></div>
                          </div>
                        </div>
                        <p className="paragraph text-center fz-12 mt-60">Haga click sobre la imagen para seleccionar una
                          ubicación del<br /> cuerpo aproximada del examen que desea agendar.</p>
                      </>
                  }
                </div>

                <div className="w-full centro mt-30 mb-30" ref={selectExamenRef}>
                  {parte && selectedTypeBenefit !== '' && (
                      <>
                        <div className="d-flex mb-10 mt-30">
                          <span className="paragraph"><strong>Seleccione nombre del examen</strong></span>
                        </div>

                        <div className="d-flex flex-center">
                          <select name="examen" id="examen" disabled={loadingSelect}
                                  className={loadingSelect ? ' wait i2b-select select-cuadrado' : 'i2b-select select-cuadrado'}
                                  onChange={e => handleSetExamen(e.target.value, e.target.options[e.target.selectedIndex].text)}>
                            {loadingSelect && (<option value="">Cargando...</option>)}
                            {!loadingSelect && (<option value="0" selected>Elija una opción</option>)}
                            {examenList.map(item => {
                              return (<option value={item.id} key={item.id}>{item.text}</option>)
                            })}
                          </select>
                        </div>

                        {loadingIndications && (<div className='spinner'></div>)}

                        {indications && (<div className='bg-blue_light fz-13 bdr-8 mt-20'>
                          <div className='fw-700 p-11 d-flex'>
                            <i className='ico-file'></i>
                            <span className='lh-18 pl-8'>
                      Indicaciones generales del examen
                    </span>
                          </div>

                          <div className='lh-20 pl-59 pb-20 pr-40 list_style-disc' dangerouslySetInnerHTML={{__html: indications}}></div>

                          <a href={urlPdf} onClick={() => setDownloadPdf(true) } target="_blank" className='bg-blue_dark btn-agenda text-white p-11 lh-20 d-flex
                      border-bottom-right-radius-8
                      border-bottom-left-radius-8
                      text-align-left pr-16'>
                            <i className='ico-file_download'></i>
                            <span className='lh-18 fw-700'>
                      Debes descargar las indicaciones completas</span>
                          </a>

                        </div>)}

                      </>
                  )}
                </div>

                {
                    (selectedTypeBenefit === 'radiografia_simple' || wayToSchedule === 'presencial') && examen !== '' && (
                        <div className='mt-30 mb-30 fz-13 lh-24 bd-radius-8 p-16 d-flex wrapper_agenda bs-border-box bg-warning'>
                          <img src="/assets/img/agenda/warning.svg" width='24' height='24' alt=""
                               className='mr-10 d-block position-relative t-3' />
                          <div className='w-316'>
                            Este examen no requiere agendamiento. Disponibilidad por orden de llegada.
                            Horario de atención de Lu. a Sá. de 09:00 a 20:00 hrs. Fines de semana y festivos de 9:00 a 19:30 hrs.
                          </div>
                        </div>
                    )
                }
                {
                    (wayToSchedule === 'callcenter') && examen !== '' && (
                        <div className='mt-30 mb-30 fz-13 lh-24 bd-radius-8 p-16 d-flex wrapper_agenda bs-border-box bg-warning'>
                          <img src="/assets/img/agenda/warning.svg" width='24' height='24' alt=""
                               className='mr-10 d-block position-relative t-3' />
                          <div className='w-316'>
                            Tu examen tiene condiciones especiales y debes llamar a nuestro call center para mayor información y
                            agendamiento al número 2 2362 5400
                          </div>
                        </div>
                    )
                }
                <div className='button-container mt-30'>
                  {(selectedTypeBenefit !== 'radiografia_simple' && wayToSchedule !== 'callcenter' && wayToSchedule !== 'presencial') && (
                      <a href="#" type="button"
                         className={canContinue &&  downloadPdf ? 'button-orange next-step-1' : 'button-orange next-step-1 disabled'}
                         onClick={() => currentStep('questions')}>CONTINUAR</a>
                  )}
                  <a href="#" onClick={() => setCurrentStep('0')}
                     className='button-border mt-15'>Atrás</a>
                </div>
              </div>
            </div>
        )}
      </>
  );
}
